import IEventProcessor from "./IEventProcessor";
import _get from 'lodash/get'
import _isNil from 'lodash/isNil'
import LudoNxEventProcessor from "./ludoNx";

export enum GAMES {
  LUDONX = 'LUDONX'
}


const GAME_NAME_PROCESSOR_CLASS_MAP = {
  [GAMES.LUDONX]: LudoNxEventProcessor
}


let processorInstance: IEventProcessor | null | undefined


export function createEventProcessor(gameName?: GAMES) {
  processorInstance = new LudoNxEventProcessor()
  // const processorClass = _get(GAME_NAME_PROCESSOR_CLASS_MAP, GAMES.LUDONX, LudoNxEventProcessor)

  // if (!_isNil(processorInstance) && processorInstance instanceof processorClass) {
  //   // logger(TAG_NAMES.LS_GAMEPLAY, 'Event Processor already exists for this game')
  //   return
  // }
  // if (!_isNil(processorInstance)) {
  //   processorInstance.clearAllTimeoutsAndIntervals()

  //   processorInstance = null
  // }

  // processorInstance = new processorClass()
}

export function getEventProcessor() {
    if (_isNil(processorInstance)) {
    //   logger(TAG_NAMES.LS_GAMEPLAY, 'Unable to process events as processor do not exist')
      return
    }
  
    return processorInstance
  }

